import React from "react";
import { FaWhatsapp } from "react-icons/fa";



const WhatsAppFloat = () => {
  
  const phoneNumber = "8483062624";

 
  const defaultMessage = encodeURIComponent("Hello, welcome to TIS.");

 
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${defaultMessage}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      style={styles.floatButton}
    >
      <FaWhatsapp size={30} color="#fff" />
    </a>
  );
};

const styles = {
  floatButton: {
    position: "fixed",
    bottom: "20px",    
    right: "20px",    
    backgroundColor: "#25D366", 
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
    zIndex: 9999,      // stays on top
    cursor: "pointer",
  },
};

export default WhatsAppFloat;
